const ENCODER = new TextEncoder();

export interface KeyPair {
	publicKey: CryptoKey;
	privateKey: CryptoKey;
}

export async function generateKeyPair(): Promise<KeyPair> {
	const keyPair = await crypto.subtle.generateKey(
		{ name: "ECDSA", namedCurve: "P-256" },
		true,
		["sign", "verify"]
	);
	return {
		publicKey: keyPair.publicKey,
		privateKey: keyPair.privateKey
	};
}

export async function exportPublicKey(publicKey: CryptoKey): Promise<JsonWebKey> {
	return await crypto.subtle.exportKey("jwk", publicKey);
}

export async function signMessage(message: string, privateKey: CryptoKey): Promise<string> {
	const messageBuffer = ENCODER.encode(message);
	const signatureBuffer = await crypto.subtle.sign(
		{ name: "ECDSA", hash: "SHA-256" },
		privateKey,
		messageBuffer
	);
	return bufferToHex(signatureBuffer);
}

export function generateUuid(): string {
	return crypto.randomUUID();
}

function bufferToHex(buffer: ArrayBuffer): string {
	return Array.from(new Uint8Array(buffer))
		.map((b) => b.toString(16).padStart(2, "0"))
		.join("");
}
